<template>
<b-container fluid class="container">
   <b-row class="justify-content-md-center">
          <b-col col md="3" class="text-center">
           <Descripcion/>
            <div class="mb-5" >
                  <img src="../assets/wizard4.png" class="img-fluid" alt="" />
            </div>
            <hr>
            <div class="mb-5">
              <h6>Estamos para ayudarte</h6>
              <p style="font-size: 15px">¿Deseas ser asistido por uno de nuestros asesores?</p>
                  <b-button @click.prevent="" variant="outline-primary" class="button_H11">ESTAMOS PARA AYUDARTE</b-button>
            </div>
          </b-col>
          <b-col col md="6" class="card-body text-center">
            <Sesion/>
            <h1 class="mt-5">Estamos a un paso de terminar</h1>
              <p class="mt-5" style="font-size: 19px">Es el momento de personalizar tu solicitud de Crédito</p>
              <h1 style="font-size: 19px">Ten a la mano los siguientes documentos:</h1>
              <p class="mt-5" style="font-size: 12px">Para el envío de esta información un asesor "Autocom" se pondrá en comunicación contigo para 
                darte el seguimiento adecuado. Espera esta ayuda en las próximas horas. La comunicación y envío de 
                documentos será por correo electrónico o por whatsapp.</p>
                <b-row class="justify-content-md-center">
                  <b-col col md="10" class="text-left mt-4">
                        <b-row>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Escoge tu enganche</h2>
                            <p style="font-size: 12px">(INE, IFE, Pasaporte o Cédula Profesional).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- CURP</h2>
                            <p style="font-size: 12px">(Qué se vean los 18 dígitos).</p>
                          </b-col>
                          <div class="w-100"></div>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Comprobante de Domicilio</h2>
                            <p style="font-size: 12px">(Que aparezca el domicilio completo; Este puede ser de CFE, Agua o Teléfono).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Licencia de Conducir</h2>
                            <p style="font-size: 12px">(Vigente).</p>
                          </b-col>
                          <div class="w-100"></div>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Comprobamte de Ingresos</h2>
                            <p style="font-size: 12px">(3 últimos recibos de nómina y 3 estasos de cuenta bancarios caratula y reflejo de depósitos).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Formato garantía</h2>
                          </b-col>
                          <div class="w-100"></div>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Carta Beneficios</h2>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Carta de conformidad</h2>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Persona Física con actividad empresarial</h2>
                            <p style="font-size: 12px">PFAE (Declaración anual de ISR, constancia de situación fiscal con cédula de indentificación 
                              fiscal incluida).</p>
                          </b-col>
                          <b-col>
                            <h2 class="text-left" style="font-size: 13px">- Extrangeros</h2>
                            <p style="font-size: 12px">(Formato migratorio: FM2-FM3).</p>
                          </b-col>
                        </b-row>
                          <b-row class="justify-content-md-center">
                             <b-col cols="12" md="auto" class="mt-5">
                               <b-button @click.prevent="" class="button_H">AGENDAR CITA</b-button>
                               <b-button @click.prevent="regresar()" variant="primary" class="button_H1">REGRESAR</b-button>
                             </b-col>
                           </b-row>
                  </b-col>
                </b-row>
          </b-col>
          <b-col col md="3" class="card-body text-center">
            <h1 style="color: #DD3E23; font-size: 25px">Aparta hoy mismo esta unidad.</h1>
            <p>Reserva esta unidad con 5 días de anticipación</p>
            <b-card style="border-color: #DD3E23" header-bg-variant="primary" header-text-variant="white" align="center">
              <p style="color: #DD3E23; font-size: 18px; font-weight: bolder;">APARTA HOY MISMO</p>
              <p style="color: #DD3E23; font-size: 15px;">PAGO REMBOLSABLE</p>
              <h1 style="color: #DD3E23; font-size: 30px;">${{this.monto}}</h1>
                <b-button @click.prevent="reserva()" class="button_conta">RESERVA AHORA</b-button>
            </b-card>
          </b-col>
    </b-row>
</b-container>
</template>

<script>
import Sesion from './Sesion.vue';
import Descripcion from './Descripcion.vue';

export default {
  name: 'Autocom',

  components: {
    Sesion,
    Descripcion
  },

    data() {
    return {

      contents: null,
      monto: sessionStorage.getItem("montoWeb"),
      autos: [],
      photos: [],
      vin: sessionStorage.getItem("vinUnidad"),
      type: sessionStorage.getItem("type"),
      paso:'',
      calculo:'',
      calculo2:'',
      calculo3:'',
      calculo4:'',
      calculo5:'',
      porcentaje: '',
      selected: '12',
      minValue: '',
      precio1: '',
      show: true,

      };
  },

  methods: {
    reserva(){
            this.$router.push({ path: '/Reserva'});
    },


    bienvenida(){
      this.$router.push({ path: '/Bienvenida'});
    },
    
    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    regresar(){
      this.$router.push({ path: '/Bienvenida'});          
    },
  },
  
  created() {

  }
}
</script>

<style scoped>


</style>